<template>
  <v-dialog
    v-model="visible"
    :persistent="persist"
    scrollable
    max-width="480px"
    @input="hide()"
  >
    <v-card>
      <v-card-title v-if="cTitle">
        <v-icon
          v-if="icon"
          large
          left
        >
          {{ icon }}
        </v-icon>
        <span class="headline">{{ cTitle }}</span>
      </v-card-title>
      <v-card-text>
        <span v-html="cMessage"></span>
        <template v-for="(qry, i) in query">
          <!-- Text Field -->
          <v-text-field
            v-if="!qry.type || qry.type === 'text'"
            :key="i"
            v-model="qry.value"
            :label="qry.label"
            :rules="qry.rules"
          >
          </v-text-field>
          <!-- CheckBox -->
          <v-checkbox
            v-if="qry.type === 'checkbox'"
            :key="i"
            v-model="qry.value"
            :label="qry.label"
          >
          </v-checkbox>
          <!-- Autocomplete -->
          <v-autocomplete
            v-if="qry.type === 'autocomplete'"
            :key="i"
            v-model="qry.value"
            :label="qry.label"
            :items="qry.items"
            menu-props="auto"
          >
          </v-autocomplete>
          <!-- Date Picker -->
          <v-menu
            v-if="qry.type === 'date-picker' || qry.type === 'datepicker'"
            :key="i"
            v-model="qry.menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="qry.value"
                :label="qry.label"
                prepend-icon-="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="qry.value" @input="qry.menu = false"></v-date-picker>
          </v-menu>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-for="(btn, i) in buttons"
          :key="i"
          :color="btn.default ? 'blue darken-1' : (btn.danger ? 'red darken-1' : '')"
          text
          @click="onBtnClick(btn)"
        >{{ btn.label ? btn.label : btn }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: ['persistent'],
  data() {
    return {
      visible: false,
      type: null,
      title: '',
      message: '',
      buttons: [],
      query: {},
    }
  },
  computed: {
    persist() {
      return this.type == 'alert' || this.type == 'error' || this.persistent // we always have btns
    },
    icon() {
      switch (this.type) {
        case 'alert' :
        case 'warning' :
          return 'mdi-alert-circle-outline'
        case 'error' :
          return 'mdi-close-octagon-outline'
        case 'confirm' :
          return 'mdi-help-circle-outline'
        case 'info' :
        case 'success' :
          return 'mdi-information-outline'
        default :
          return null
      }
    },
    cTitle() {
      return this.title
        ? this.title
        : (
          this.type
            ? this.type.capitalize()
            : null
        )
    },
    cMessage() {
      return (typeof this.message === 'function'
        ? this.message()
        : this.message).replace(/\n/g, '<br />')
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('close')
      }
    },
  },
  created() {
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 13) {
        this.onDefault()
      }
      if (evt.keyCode == 27 && !this.persistent) {
        this.hide()
      }
    }
  },
  methods: {
    show({ type, title, message, buttons, query }) {
// console.log(type, title, message, buttons, query)
      this.type = type || null
      this.title = title || ''
      this.message = message || ''
      this.query = query || {}
      Object.keys(this.query).forEach(key => {
        this.query[key].value = this.query[key].value || null
      })
      this.buttons = buttons || []
      if (!this.buttons.length) {
        this.buttons.push({
          label: 'OK',
          close: true,
          default: true,
        })
      }
      this.visible = true
    },
    hide() {
      this.$emit('hide')
      this.visible = false
    },
    onBtnClick(btn) {
      if (btn.callback) {
        btn.callback(this.query)
      } else {
        this.$emit(btn.label ? btn.label : btn.toString(), this.query)
      }
      if (btn.close) {
        this.hide()
      }
    },
    onDefault() {
      if (this.buttons) {
        const btn = this.buttons.find(a => a.default)
        if (btn) {
          this.onBtnClick(btn)
        }
      } else {
        this.onOk()
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
